import "core-js/modules/es.array.sort.js";
/* eslint-disable */
// @ts-nocheck
// Ignore all typing checks, too much wrk to type when we should never be touching this file.
import { DefaultLoadingManager, FileLoader, Vector3, Matrix4, MeshBasicMaterial, BufferGeometry, Float32BufferAttribute, Bone, Group, LineSegments, Line, Mesh, Scene, Euler } from "three";
/**
 * @author mrdoob / http://mrdoob.com/
 * @author Mugen87 / https://github.com/Mugen87
 */
export class ColladaLoader {
  constructor(manager) {
    Object.defineProperty(this, "_manager", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_path", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._manager = manager !== undefined ? manager : DefaultLoadingManager;
  }
  load(url, onLoad) {
    let onProgress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    let onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    const loader = new FileLoader(this._manager);
    loader.setPath(this._path);
    loader.load(url, text => {
      onLoad(this.parse(text));
    }, onProgress, onError);
  }
  setPath(value) {
    this._path = value;
  }
  // @ts-ignore
  // eslint-disable-next-line class-methods-use-this
  parse(text) {
    let count = 0;
    const matrix = new Matrix4();
    const vector = new Vector3();
    const library = {
      animations: {},
      clips: {},
      controllers: {},
      images: {},
      effects: {},
      materials: {},
      cameras: {},
      lights: {},
      geometries: {},
      nodes: {},
      visualScenes: {},
      kinematicsModels: {},
      physicsModels: {},
      kinematicsScenes: {}
    };
    function getElementsByTagName(xml, name) {
      // Non recursive xml.getElementsByTagName() ...
      const array = [];
      const {
        childNodes
      } = xml;
      for (let i = 0, l = childNodes.length; i < l; i++) {
        const child = childNodes[i];
        if (child.nodeName === name) {
          array.push(child);
        }
      }
      return array;
    }
    function parseStrings(input) {
      if (input.length === 0) return [];
      const parts = input.trim().split(/\s+/);
      const array = new Array(parts.length);
      for (let i = 0, l = parts.length; i < l; i++) {
        array[i] = parts[i];
      }
      return array;
    }
    function parseFloats(input) {
      if (input.length === 0) return [];
      const parts = input.trim().split(/\s+/);
      const array = new Array(parts.length);
      for (let i = 0, l = parts.length; i < l; i++) {
        array[i] = parseFloat(parts[i]);
      }
      return array;
    }
    function parseInts(input) {
      if (input.length === 0) return [];
      const parts = input.trim().split(/\s+/);
      const array = new Array(parts.length);
      for (let i = 0, l = parts.length; i < l; i++) {
        // eslint-disable-next-line radix
        array[i] = parseInt(parts[i]);
      }
      return array;
    }
    function parseId(input) {
      return input.substring(1);
    }
    function generateId() {
      // eslint-disable-next-line no-plusplus
      return "three_default_".concat(count++);
    }
    // asset
    function parseAssetUnit(xml) {
      if (xml !== undefined && xml.hasAttribute("meter") === true) {
        return parseFloat(xml.getAttribute("meter"));
      }
      return 1; // default 1 meter
    }
    function parseAssetUpAxis(xml) {
      return xml !== undefined ? xml.textContent : "Y_UP";
    }
    function parseAsset(xml) {
      return {
        unit: parseAssetUnit(getElementsByTagName(xml, "unit")[0]),
        upAxis: parseAssetUpAxis(getElementsByTagName(xml, "up_axis")[0])
      };
    }
    // library
    function parseLibrary(xml, libraryName, nodeName, parser) {
      const libraryElements = getElementsByTagName(xml, libraryName)[0];
      if (libraryElements !== undefined) {
        const elements = getElementsByTagName(libraryElements, nodeName);
        for (let i = 0; i < elements.length; i++) {
          parser(elements[i]);
        }
      }
    }
    // get
    function getBuild(data, builder) {
      if (data.build !== undefined) return data.build;
      data.build = builder(data);
      return data.build;
    }
    function buildSkin(data) {
      const BONE_LIMIT = 4;
      // array sort function
      function descending(a, b) {
        return b.weight - a.weight;
      }
      const build = {
        joints: [],
        // this must be an array to preserve the joint order
        indices: {
          array: [],
          stride: BONE_LIMIT
        },
        weights: {
          array: [],
          stride: BONE_LIMIT
        }
      };
      const {
        sources
      } = data;
      const {
        vertexWeights
      } = data;
      const {
        vcount
      } = vertexWeights;
      const {
        v
      } = vertexWeights;
      const jointOffset = vertexWeights.inputs.JOINT.offset;
      const weightOffset = vertexWeights.inputs.WEIGHT.offset;
      const jointSource = data.sources[data.joints.inputs.JOINT];
      const inverseSource = data.sources[data.joints.inputs.INV_BIND_MATRIX];
      const weights = sources[vertexWeights.inputs.WEIGHT.id].array;
      let stride = 0;
      let i;
      let j;
      let l;
      // procces skin data for each vertex
      for (i = 0, l = vcount.length; i < l; i++) {
        const jointCount = vcount[i]; // this is the amount of joints that affect a single vertex
        const vertexSkinData = [];
        for (j = 0; j < jointCount; j++) {
          const skinIndex = v[stride + jointOffset];
          const weightId = v[stride + weightOffset];
          const skinWeight = weights[weightId];
          vertexSkinData.push({
            index: skinIndex,
            weight: skinWeight
          });
          stride += 2;
        }
        // we sort the joints in descending order based on the weights.
        // this ensures, we only procced the most important joints of the vertex
        vertexSkinData.sort(descending);
        // now we provide for each vertex a set of four index and weight values.
        // the order of the skin data matches the order of vertices
        for (j = 0; j < BONE_LIMIT; j++) {
          const d = vertexSkinData[j];
          if (d !== undefined) {
            build.indices.array.push(d.index);
            build.weights.array.push(d.weight);
          } else {
            build.indices.array.push(0);
            build.weights.array.push(0);
          }
        }
      }
      // setup bind matrix
      if (data.bindShapeMatrix) {
        build.bindMatrix = new Matrix4().fromArray(data.bindShapeMatrix).transpose();
      } else {
        build.bindMatrix = new Matrix4().identity();
      }
      // process bones and inverse bind matrix data
      for (i = 0, l = jointSource.array.length; i < l; i++) {
        const name = jointSource.array[i];
        const boneInverse = new Matrix4().fromArray(inverseSource.array, i * inverseSource.stride).transpose();
        build.joints.push({
          name,
          boneInverse
        });
      }
      return build;
    }
    function buildController(data) {
      const build = {
        id: data.id
      };
      const geometry = library.geometries[build.id];
      if (data.skin !== undefined) {
        build.skin = buildSkin(data.skin);
        // we enhance the 'sources' property of the corresponding geometry with our skin data
        geometry.sources.skinIndices = build.skin.indices;
        geometry.sources.skinWeights = build.skin.weights;
      }
      return build;
    }
    function getController(id) {
      return getBuild(library.controllers[id], buildController);
    }
    // effect
    // geometry
    function parseSource(xml) {
      const data = {
        array: [],
        stride: 3
      };
      for (let i = 0; i < xml.childNodes.length; i++) {
        const child = xml.childNodes[i];
        let accessor;
        // eslint-disable-next-line no-continue
        if (child.nodeType !== 1) continue;
        // eslint-disable-next-line default-case
        switch (child.nodeName) {
          case "float_array":
            data.array = parseFloats(child.textContent);
            break;
          case "Name_array":
            data.array = parseStrings(child.textContent);
            break;
          case "technique_common":
            // eslint-disable-next-line prefer-destructuring
            accessor = getElementsByTagName(child, "accessor")[0];
            if (accessor !== undefined) {
              data.stride = parseInt(accessor.getAttribute("stride"));
            }
            break;
        }
      }
      return data;
    }
    function parseGeometryVertices(xml) {
      const data = {};
      for (let i = 0; i < xml.childNodes.length; i++) {
        const child = xml.childNodes[i];
        if (child.nodeType !== 1) continue;
        data[child.getAttribute("semantic")] = parseId(child.getAttribute("source"));
      }
      return data;
    }
    function parseGeometryPrimitive(xml) {
      const primitive = {
        type: xml.nodeName,
        material: xml.getAttribute("material"),
        count: parseInt(xml.getAttribute("count")),
        inputs: {},
        stride: 0,
        hasUV: false
      };
      for (let i = 0, l = xml.childNodes.length; i < l; i++) {
        const child = xml.childNodes[i];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "input":
            const id = parseId(child.getAttribute("source"));
            const semantic = child.getAttribute("semantic");
            const offset = parseInt(child.getAttribute("offset"));
            const set = parseInt(child.getAttribute("set"));
            const inputname = set > 0 ? semantic + set : semantic;
            primitive.inputs[inputname] = {
              id,
              offset
            };
            primitive.stride = Math.max(primitive.stride, offset + 1);
            if (semantic === "TEXCOORD") primitive.hasUV = true;
            break;
          case "vcount":
            primitive.vcount = parseInts(child.textContent);
            break;
          case "p":
            primitive.p = parseInts(child.textContent);
            break;
        }
      }
      return primitive;
    }
    function parseGeometry(xml) {
      const data = {
        name: xml.getAttribute("name"),
        sources: {},
        vertices: {},
        primitives: []
      };
      const mesh = getElementsByTagName(xml, "mesh")[0];
      // the following tags inside geometry are not supported yet (see https://github.com/mrdoob/three.js/pull/12606): convex_mesh, spline, brep
      if (mesh === undefined) return;
      for (let i = 0; i < mesh.childNodes.length; i++) {
        const child = mesh.childNodes[i];
        if (child.nodeType !== 1) continue;
        const id = child.getAttribute("id");
        switch (child.nodeName) {
          case "source":
            data.sources[id] = parseSource(child);
            break;
          case "vertices":
            // data.sources[ id ] = data.sources[ parseId( getElementsByTagName( child, 'input' )[ 0 ].getAttribute( 'source' ) ) ];
            data.vertices = parseGeometryVertices(child);
            break;
          case "polygons":
            console.warn("THREE.ColladaLoader: Unsupported primitive type: ", child.nodeName);
            break;
          case "lines":
          case "linestrips":
          case "polylist":
          case "triangles":
            data.primitives.push(parseGeometryPrimitive(child));
            break;
          default:
            console.log(child);
        }
      }
      library.geometries[xml.getAttribute("id")] = data;
    }
    function groupPrimitives(primitives) {
      const build = {};
      for (let i = 0; i < primitives.length; i++) {
        const primitive = primitives[i];
        if (build[primitive.type] === undefined) build[primitive.type] = [];
        build[primitive.type].push(primitive);
      }
      return build;
    }
    function checkUVCoordinates(primitives) {
      let _count = 0;
      for (let i = 0, l = primitives.length; i < l; i++) {
        const primitive = primitives[i];
        if (primitive.hasUV === true) {
          _count++;
        }
      }
      if (_count > 0 && _count < primitives.length) {
        primitives.uvsNeedsFix = true;
      }
    }
    function buildGeometryData(primitive, source, offset, array) {
      const indices = primitive.p;
      const {
        stride
      } = primitive;
      const {
        vcount
      } = primitive;
      const sourceArray = source.array;
      const sourceStride = source.stride;
      function pushVector(i) {
        let index = indices[i + offset] * sourceStride;
        const length = index + sourceStride;
        for (; index < length; index++) {
          array.push(sourceArray[index]);
        }
      }
      if (primitive.vcount !== undefined) {
        let index = 0;
        for (let i = 0, l = vcount.length; i < l; i++) {
          const counter = vcount[i];
          if (counter === 4) {
            const a = index + stride * 0;
            const b = index + stride * 1;
            const c = index + stride * 2;
            const d = index + stride * 3;
            pushVector(a);
            pushVector(b);
            pushVector(d);
            pushVector(b);
            pushVector(c);
            pushVector(d);
          } else if (counter === 3) {
            const a = index + stride * 0;
            const b = index + stride * 1;
            const c = index + stride * 2;
            pushVector(a);
            pushVector(b);
            pushVector(c);
          } else if (counter > 4) {
            for (let k = 1, kl = counter - 2; k <= kl; k++) {
              const a = index + stride * 0;
              const b = index + stride * k;
              const c = index + stride * (k + 1);
              pushVector(a);
              pushVector(b);
              pushVector(c);
            }
          }
          index += stride * counter;
        }
      } else {
        for (let i = 0, l = indices.length; i < l; i += stride) {
          pushVector(i);
        }
      }
    }
    function buildGeometryType(primitives, sources, vertices) {
      const build = {};
      const position = {
        array: [],
        stride: 0
      };
      const normal = {
        array: [],
        stride: 0
      };
      const uv = {
        array: [],
        stride: 0
      };
      const uv2 = {
        array: [],
        stride: 0
      };
      const color = {
        array: [],
        stride: 0
      };
      const skinIndex = {
        array: [],
        stride: 4
      };
      const skinWeight = {
        array: [],
        stride: 4
      };
      const geometry = new BufferGeometry();
      const materialKeys = [];
      let start = 0;
      for (let p = 0; p < primitives.length; p++) {
        const primitive = primitives[p];
        const {
          inputs
        } = primitive;
        // groups
        let _count = 0;
        switch (primitive.type) {
          case "lines":
          case "linestrips":
            _count = primitive.count * 2;
            break;
          case "triangles":
            _count = primitive.count * 3;
            break;
          case "polylist":
            for (let g = 0; g < primitive.count; g++) {
              const vc = primitive.vcount[g];
              switch (vc) {
                case 3:
                  _count += 3; // single triangle
                  break;
                case 4:
                  _count += 6; // quad, subdivided into two triangles
                  break;
                default:
                  _count += (vc - 2) * 3; // polylist with more than four vertices
                  break;
              }
            }
            break;
          default:
            console.warn("THREE.ColladaLoader: Unknow primitive type:", primitive.type);
        }
        geometry.addGroup(start, _count, p);
        start += _count;
        // material
        if (primitive.material) {
          materialKeys.push(primitive.material);
        }
        // geometry data
        for (const name in inputs) {
          const input = inputs[name];
          switch (name) {
            case "VERTEX":
              for (const key in vertices) {
                const id = vertices[key];
                switch (key) {
                  case "POSITION":
                    const prevLength = position.array.length;
                    buildGeometryData(primitive, sources[id], input.offset, position.array);
                    position.stride = sources[id].stride;
                    if (sources.skinWeights && sources.skinIndices) {
                      buildGeometryData(primitive, sources.skinIndices, input.offset, skinIndex.array);
                      buildGeometryData(primitive, sources.skinWeights, input.offset, skinWeight.array);
                    }
                    // see #3803
                    if (primitive.hasUV === false && primitives.uvsNeedsFix === true) {
                      const counter = (position.array.length - prevLength) / position.stride;
                      for (let i = 0; i < counter; i++) {
                        // fill missing uv coordinates
                        uv.array.push(0, 0);
                      }
                    }
                    break;
                  case "NORMAL":
                    buildGeometryData(primitive, sources[id], input.offset, normal.array);
                    normal.stride = sources[id].stride;
                    break;
                  case "COLOR":
                    buildGeometryData(primitive, sources[id], input.offset, color.array);
                    color.stride = sources[id].stride;
                    break;
                  case "TEXCOORD":
                    buildGeometryData(primitive, sources[id], input.offset, uv.array);
                    uv.stride = sources[id].stride;
                    break;
                  case "TEXCOORD1":
                    buildGeometryData(primitive, sources[id], input.offset, uv2.array);
                    uv.stride = sources[id].stride;
                    break;
                  default:
                    console.warn('THREE.ColladaLoader: Semantic "%s" not handled in geometry build process.', key);
                }
              }
              break;
            case "NORMAL":
              buildGeometryData(primitive, sources[input.id], input.offset, normal.array);
              normal.stride = sources[input.id].stride;
              break;
            case "COLOR":
              buildGeometryData(primitive, sources[input.id], input.offset, color.array);
              color.stride = sources[input.id].stride;
              break;
            case "TEXCOORD":
              buildGeometryData(primitive, sources[input.id], input.offset, uv.array);
              uv.stride = sources[input.id].stride;
              break;
            case "TEXCOORD1":
              buildGeometryData(primitive, sources[input.id], input.offset, uv2.array);
              uv2.stride = sources[input.id].stride;
              break;
          }
        }
      }
      // build geometry
      if (position.array.length > 0) geometry.setAttribute("position", new Float32BufferAttribute(position.array, position.stride));
      if (normal.array.length > 0) geometry.setAttribute("normal", new Float32BufferAttribute(normal.array, normal.stride));
      if (color.array.length > 0) geometry.setAttribute("color", new Float32BufferAttribute(color.array, color.stride));
      if (uv.array.length > 0) geometry.setAttribute("uv", new Float32BufferAttribute(uv.array, uv.stride));
      if (uv2.array.length > 0) geometry.setAttribute("uv2", new Float32BufferAttribute(uv2.array, uv2.stride));
      if (skinIndex.array.length > 0) geometry.setAttribute("skinIndex", new Float32BufferAttribute(skinIndex.array, skinIndex.stride));
      if (skinWeight.array.length > 0) geometry.setAttribute("skinWeight", new Float32BufferAttribute(skinWeight.array, skinWeight.stride));
      build.data = geometry;
      build.type = primitives[0].type;
      build.materialKeys = materialKeys;
      return build;
    }
    function buildGeometry(data) {
      const build = {};
      const {
        sources
      } = data;
      const {
        vertices
      } = data;
      const {
        primitives
      } = data;
      if (primitives.length === 0) return {};
      // our goal is to create one buffer geometry for a single type of primitives
      // first, we group all primitives by their type
      const groupedPrimitives = groupPrimitives(primitives);
      for (const type in groupedPrimitives) {
        const primitiveType = groupedPrimitives[type];
        // second, ensure consistent uv coordinates for each type of primitives (polylist,triangles or lines)
        checkUVCoordinates(primitiveType);
        // third, create a buffer geometry for each type of primitives
        build[type] = buildGeometryType(primitiveType, sources, vertices);
        build[type].data.name = data.name;
      }
      return build;
    }
    function getGeometry(id) {
      return getBuild(library.geometries[id], buildGeometry);
    }
    // kinematics
    // physics
    // scene
    // nodes
    function hasNode(id) {
      return library.nodes[id] !== undefined;
    }
    function prepareNodes(xml) {
      const elements = xml.getElementsByTagName("node");
      // ensure all node elements have id attributes
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        if (element.hasAttribute("id") === false) {
          element.setAttribute("id", generateId());
        }
      }
    }
    function parseNodeInstance(xml) {
      const data = {
        id: parseId(xml.getAttribute("url")),
        materials: {}
      };
      for (let i = 0; i < xml.childNodes.length; i++) {
        const child = xml.childNodes[i];
        switch (child.nodeName) {
          case "bind_material":
            const instances = child.getElementsByTagName("instance_material");
            for (let j = 0; j < instances.length; j++) {
              const instance = instances[j];
              const symbol = instance.getAttribute("symbol");
              const target = instance.getAttribute("target");
              data.materials[symbol] = parseId(target);
            }
            break;
          default:
            break;
        }
      }
      return data;
    }
    function parseNode(xml) {
      const data = {
        name: xml.getAttribute("name") || "",
        type: xml.getAttribute("type"),
        id: xml.getAttribute("id"),
        sid: xml.getAttribute("sid"),
        matrix: new Matrix4(),
        nodes: [],
        instanceControllers: [],
        instanceLights: [],
        instanceGeometries: [],
        instanceNodes: [],
        transforms: {}
      };
      for (let i = 0; i < xml.childNodes.length; i++) {
        const child = xml.childNodes[i];
        let array;
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "node":
            data.nodes.push(child.getAttribute("id"));
            parseNode(child);
            break;
          case "instance_controller":
            data.instanceControllers.push(parseNodeInstance(child));
            break;
          case "instance_geometry":
            data.instanceGeometries.push(parseNodeInstance(child));
            break;
          case "instance_node":
            data.instanceNodes.push(parseId(child.getAttribute("url")));
            break;
          case "matrix":
            array = parseFloats(child.textContent);
            data.matrix.multiply(matrix.fromArray(array).transpose());
            data.transforms[child.getAttribute("sid")] = child.nodeName;
            break;
          case "translate":
            array = parseFloats(child.textContent);
            vector.fromArray(array);
            data.matrix.multiply(matrix.makeTranslation(vector.x, vector.y, vector.z));
            data.transforms[child.getAttribute("sid")] = child.nodeName;
            break;
          case "rotate":
            array = parseFloats(child.textContent);
            const angle = array[3] * Math.PI / 180;
            data.matrix.multiply(matrix.makeRotationAxis(vector.fromArray(array), angle));
            data.transforms[child.getAttribute("sid")] = child.nodeName;
            break;
          case "scale":
            array = parseFloats(child.textContent);
            data.matrix.scale(vector.fromArray(array));
            data.transforms[child.getAttribute("sid")] = child.nodeName;
            break;
          case "extra":
            break;
          default:
            console.log(child);
        }
      }
      if (hasNode(data.id)) {
        console.warn("THREE.ColladaLoader: There is already a node with ID %s. Exclude current node from further processing.", data.id);
      } else {
        library.nodes[data.id] = data;
      }
      return data;
    }
    const fallbackMaterial = new MeshBasicMaterial({
      color: 0xff00ff
    });
    function buildObjects(geometries) {
      const objects = [];
      for (const type in geometries) {
        const geometry = geometries[type];
        const material = fallbackMaterial;
        // now create a specific 3D object
        let object;
        switch (type) {
          case "lines":
            object = new LineSegments(geometry.data, material);
            break;
          case "linestrips":
            object = new Line(geometry.data, material);
            break;
          case "triangles":
          case "polylist":
            object = new Mesh(geometry.data, material);
            break;
        }
        // Fix issue with loading DAE files that doesn't have names for Mesh elements
        if (object.name === "" && geometry.data.name) {
          object.uuid = geometry.data.name.replace("Mesh", "");
        }
        objects.push(object);
      }
      return objects;
    }
    function buildNode(data) {
      const objects = [];
      const {
        matrix: _matrix
      } = data;
      const {
        nodes
      } = data;
      const {
        type
      } = data;
      const {
        instanceControllers
      } = data;
      const {
        instanceGeometries
      } = data;
      const {
        instanceNodes
      } = data;
      // nodes
      for (let i = 0, l = nodes.length; i < l; i++) {
        // eslint-disable-next-line no-use-before-define
        objects.push(getNode(nodes[i]));
      }
      // instance controllers
      for (let i = 0, l = instanceControllers.length; i < l; i++) {
        const instance = instanceControllers[i];
        const controller = getController(instance.id);
        const geometries = getGeometry(controller.id);
        const newObjects = buildObjects(geometries);
        for (let j = 0, jl = newObjects.length; j < jl; j++) {
          const object = newObjects[j];
          objects.push(object);
        }
      }
      // instance geometries
      for (let i = 0, l = instanceGeometries.length; i < l; i++) {
        const instance = instanceGeometries[i];
        // a single geometry instance in collada can lead to multiple object3Ds.
        // this is the case when primitives are combined like triangles and lines
        const geometries = getGeometry(instance.id);
        const newObjects = buildObjects(geometries);
        for (let j = 0, jl = newObjects.length; j < jl; j++) {
          objects.push(newObjects[j]);
        }
      }
      // instance nodes
      for (let i = 0, l = instanceNodes.length; i < l; i++) {
        // eslint-disable-next-line no-use-before-define
        objects.push(getNode(instanceNodes[i]).clone());
      }
      let object;
      if (nodes.length === 0 && objects.length === 1) {
        // eslint-disable-next-line prefer-destructuring
        object = objects[0];
      } else {
        object = type === "JOINT" ? new Bone() : new Group();
        for (let i = 0; i < objects.length; i++) {
          object.add(objects[i]);
        }
      }
      if (object.name === "") {
        object.name = type === "JOINT" ? data.sid : data.name;
        object.uuid = data.id;
      }
      object.matrix.copy(_matrix);
      object.matrix.decompose(object.position, object.quaternion, object.scale);
      return object;
    }
    function getNode(id) {
      return getBuild(library.nodes[id], buildNode);
    }
    // visual scenes
    function parseVisualScene(xml) {
      const data = {
        name: xml.getAttribute("name"),
        children: []
      };
      prepareNodes(xml);
      const elements = getElementsByTagName(xml, "node");
      for (let i = 0; i < elements.length; i++) {
        data.children.push(parseNode(elements[i]));
      }
      library.visualScenes[xml.getAttribute("id")] = data;
    }
    function buildVisualScene(data) {
      const group = new Group();
      group.name = data.name;
      const {
        children
      } = data;
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        group.add(getNode(child.id));
      }
      return group;
    }
    function getVisualScene(id) {
      return getBuild(library.visualScenes[id], buildVisualScene);
    }
    // scenes
    function parseScene(xml) {
      const instance = getElementsByTagName(xml, "instance_visual_scene")[0];
      return getVisualScene(parseId(instance.getAttribute("url")));
    }
    // convert the parser error element into text with each child elements text
    // separated by new lines.
    function parserErrorToText(parserError) {
      let result = "";
      const stack = [parserError];
      while (stack.length) {
        const node = stack.shift();
        if (node.nodeType === Node.TEXT_NODE) {
          result += node.textContent;
        } else {
          result += "\n";
          // eslint-disable-next-line prefer-spread
          stack.push.apply(stack, node.childNodes);
        }
      }
      return result.trim();
    }
    if (text.length === 0) {
      return {
        scene: new Scene()
      };
    }
    const xml = new DOMParser().parseFromString(text, "application/xml");
    const collada = getElementsByTagName(xml, "COLLADA")[0];
    const parserError = xml.getElementsByTagName("parsererror")[0];
    if (parserError !== undefined) {
      // Chrome will return parser error with a div in it
      const errorElement = getElementsByTagName(parserError, "div")[0];
      let errorText;
      if (errorElement) {
        errorText = errorElement.textContent;
      } else {
        errorText = parserErrorToText(parserError);
      }
      console.error("THREE.ColladaLoader: Failed to parse collada file.\n", errorText);
      return null;
    }
    const asset = parseAsset(getElementsByTagName(collada, "asset")[0]);
    parseLibrary(collada, "library_geometries", "geometry", parseGeometry);
    parseLibrary(collada, "library_visual_scenes", "visual_scene", parseVisualScene);
    const scene = parseScene(getElementsByTagName(collada, "scene")[0]);
    if (asset.upAxis === "Z_UP") {
      scene.quaternion.setFromEuler(new Euler(-Math.PI / 2, 0, 0));
    }
    scene.scale.multiplyScalar(asset.unit);
    return {
      library,
      scene
    };
  }
}